import React from 'react';
import PropTypes from 'prop-types';
import { Button, Flex, Select } from '@chakra-ui/react';
import CommonSearch from 'components/commonSearchBar/CommonSearch';

const CouponListFilter = ({
  search,
  setSearch,
  status,
  setStatus,
  setPage,
  type,
  setType,
}) => {
  return (
    <>
      <Flex
        alignItems={'center'}
        flexWrap={'wrap'}
        mb={4}
        gap={{ base: '14px', md: '20px' }}
      >
        {/* Search Filter */}
        <Flex
          gap={{ base: '10px', md: '20px' }}
          width={{ base: '100%', md: 'auto' }}
          alignItems={{ base: 'start', md: 'center' }}
          flexDirection={{ base: 'column', md: 'row' }}
        >
          <label>Search:</label>
          <CommonSearch
            search={search}
            setSearch={setSearch}
            setPage={setPage}
          />
        </Flex>

        {/* Status Filter */}
        <Flex
          gap={{ base: '10px', md: '20px' }}
          width={{ base: '100%', md: 'auto' }}
          alignItems={{ base: 'start', md: 'center' }}
          flexDirection={{ base: 'column', md: 'row' }}
        >
          <label>Status:</label>
          <Select
            value={status}
            onChange={(e) => {
              setPage(1);
              setStatus(e.target.value);
            }}
            width={{ base: '100%', md: '200px' }}
            background={'#fff'}
            borderRadius="10px"
          >
            <option value="">All Status</option>
            <option value={true}>Active</option>
            <option value={false}>Inactive</option>
          </Select>
        </Flex>
        <Flex
          gap={{ base: '10px', md: '20px' }}
          width={{ base: '100%', md: 'auto' }}
          alignItems={{ base: 'start', md: 'center' }}
          flexDirection={{ base: 'column', md: 'row' }}
        >
          <label>Type:</label>
          <Select
            value={type}
            onChange={(e) => {
              setPage(1);
              setType(e.target.value);
            }}
            width={{ base: '100%', md: '200px' }}
            background={'#fff'}
            borderRadius="10px"
          >
            <option value="">All Types</option>
            <option value="percentage">Percentage</option>
            <option value="fixed">Fixed</option>
            <option value="time">Minutes</option>
          </Select>
        </Flex>

        {/* Reset Button */}
        <Flex gap={{ base: '14px', md: '20px' }} alignItems="center">
          <Button
            onClick={() => {
              setPage(1);
              setStatus('');
              setSearch('');
              setType('');
            }}
          >
            Reset
          </Button>
        </Flex>
      </Flex>
    </>
  );
};

CouponListFilter.propTypes = {
  search: PropTypes.string,
  setSearch: PropTypes.func,
  status: PropTypes.string,
  setStatus: PropTypes.func,
  setPage: PropTypes.func,
  type: PropTypes.string,
  setType: PropTypes.func,
};

export default CouponListFilter;
